'use strict';

import React, { Component } from 'react';
import { connect } from 'react-redux'

class CloseChat extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
        <svg className="closeChat" width="14" height="14" viewBox="0 0 14 14" onClick={this.props.onEndChat}>
          <g stroke="none" fill="currentColor">
              <path d="M8.72,9.28a.47.47,0,0,0-.47.47v2H5.42V2.22H8.26v2a.47.47,0,1,0,.93,0V1.76a.47.47,0,0,0-.47-.47H5.42V.47A.47.47,0,0,0,4.79,0L.31,1.66A.47.47,0,0,0,0,2.1v9.79a.47.47,0,0,0,.31.44L4.79,14,5,14a.47.47,0,0,0,.27-.08.46.46,0,0,0,.2-.38v-.87h3.3a.47.47,0,0,0,.47-.47V9.75A.47.47,0,0,0,8.72,9.28ZM4.49,12.86.93,11.57V2.43L4.49,1.13Z"/>
              <path d="M13.85,6.62l-2-2a.5.5,0,1,0-.7.71l1.11,1.09H6.5a.51.51,0,0,0,0,1h5.77L11.13,8.61a.5.5,0,1,0,.7.71l2-2a.5.5,0,0,0,0-.71Z"/>
          </g>
        </svg>
    );
  }
}


CloseChat.displayName = 'CloseChat';
CloseChat.propTypes = {
    onEndChat: React.PropTypes.func
};

export default connect()(CloseChat);



// WEBPACK FOOTER //
// ./src/components/CloseChat.js